import { FC, useEffect, useRef, useState } from 'react';
import { AllieText } from '../../../../components';
import { AllieColors } from '../../../../common/color.types';
import './TextCell.css';

interface TextCellProps {
  reason?: string;
  isNewId: boolean;
  labelColor?: AllieColors;
  countTotal?: number;
  isGroupable?: boolean;
}

const namespace = 'timegrid__text-cell';

const getCountCellById = (target: HTMLDivElement) => {
  let count = 0;
  let sibling = target;
  const currentId = target.dataset.id;

  while (sibling && sibling.dataset.id === currentId) {
    count++;
    sibling = sibling.nextElementSibling as HTMLDivElement;
  }

  return count;
};

export const TextCell: FC<TextCellProps> = ({
  reason,
  isNewId,
  labelColor,
  isGroupable,
}) => {
  if (!reason || !isNewId) {
    return null;
  }

  const [width, setWidth] = useState<number | null>(null);
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current) {
      if (isGroupable) {
        setWidth(containerRef.current.offsetWidth - 20); // 20 for padding
      } else {
        const parentElement = containerRef.current.parentElement;
      if (parentElement instanceof HTMLDivElement) {
        setWidth(
          containerRef.current.offsetWidth * getCountCellById(parentElement) -
            20
        ); // 20 for padding
      }
      }
    }
  }, [containerRef.current?.offsetWidth]);

  return (
    <div ref={containerRef} className={namespace}>
      <div className="text-label" {...(width && { style: { width } })}>
        <AllieText type="button-normal" color={labelColor || 'white'}>
          {reason}
        </AllieText>
      </div>
    </div>
  );
};
